import React from 'react';
import classnames from 'classnames';
import BreadcrumbsLinks from '@components/breadcrumbs';
import Link from '@components/link';
import strings from '../../strings';
import * as styles from './Breadcrumbs.scss';
import { makeRatingFaqUrl } from '../../utils/urlProvider';

const Breadcrumbs = () => (
  <div className={styles.breadcrumbs}>
    <BreadcrumbsLinks
      links={[
        {
          'name': strings.main,
          'href': '/',
          'id': 1,
        },
        {
          'name': strings.rating,
          'id': 2,
        },
      ]}
    />
    <a
      href={makeRatingFaqUrl()}
      target="_blank"
      className={classnames(styles.faq, 'glz-link', 'glz-is-medium', 'glz-is-gray')}
      rel="noreferrer"
    >
      <Link theme="gray" className={styles.faqText}>
        <span>{strings.faq}</span>
      </Link>
    </a>
  </div>
);

export default Breadcrumbs;
